// 引入mockjs
const Mock = require('mockjs');
// 获取 mock.Random 对象
const Random = Mock.Random;
// mock一组数据
const productData = function() {
  let Data = [];
  for (let i = 0; i < 8; i++) {
    let data = {
      a: Random.cname(), // Random.cname() 随机生成一个常见的中文姓名
      b: Random.date(),  // Random.date()指示生成的日期字符串的格式,默认为yyyy-MM-dd
      c: Random.city(),  // Random.city() 随机生成一个城市的名字
    }
    Data.push(data)
  }
 
  return {
    Data: Data
  }
}
 
// Mock.mock( url, post/get , 返回的数据)；
// Mock.mock('/user/login', 'post', productData );
// Mock.mock('/user/query', 'post', productData);



// WEBPACK FOOTER //
// ./src/mock.js